import type * as lazyIndex from './lazyIndex';
import { LazyAction, LazyModule, LazyImport, createLazyComponent } from 'owa-bundling';
import { getStore } from './store/store';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "RulesOptions" */ './lazyIndex'),
    { name: 'RulesOptions' }
);

// Type exports
export type { default as InboxRuleActionSource } from './store/schema/InboxRuleActionSource';
export type { RuleBulkActionCustomData } from './actions/types/RuleBulkActionCustomData';

// Lazy Components
export const InboxRulesFull: typeof lazyIndex.InboxRulesFull = createLazyComponent(
    lazyModule,
    m => m.InboxRulesFull
);
export const LazyAttachedInboxRulesDialog: typeof lazyIndex.AttachedInboxRulesDialog =
    createLazyComponent(lazyModule, m => m.AttachedInboxRulesDialog, undefined, undefined, {
        onlyImportIf: () => !!getStore().attachedInboxRulesDialogState,
    });

// Lazy Imports
export const lazyRunRuleNow: LazyImport<typeof lazyIndex.runRuleNow, typeof lazyModule> =
    new LazyImport(lazyModule, m => m.runRuleNow);
export const lazyInitializeInboxRulesEditData: LazyImport<
    typeof lazyIndex.initializeInboxRulesEditData,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.initializeInboxRulesEditData);

export const lazyGetInboxRulesAttachedToFolder: LazyAction<
    typeof lazyIndex.getInboxRulesAttachedToFolder,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.getInboxRulesAttachedToFolder);

// Lazy Actions
export const lazyCreateNewFolderInboxRules: LazyAction<
    typeof lazyIndex.createNewFolderInboxRules,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.createNewFolderInboxRules);
export const lazyNewInboxRuleAction: LazyAction<
    typeof lazyIndex.newInboxRuleAction,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.newInboxRuleAction);
export const lazyMapInboxRuleToInboxRuleClauses: LazyAction<
    typeof lazyIndex.mapInboxRuleToInboxRuleClauses,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.mapInboxRuleToInboxRuleClauses);

export const lazyGetMoveToAlertInboxRules: LazyAction<
    typeof lazyIndex.getMoveToAlertInboxRules,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.getMoveToAlertInboxRules);

export const lazySetAttachedInboxRulesDialogStateMutator: LazyAction<
    typeof lazyIndex.setAttachedInboxRulesDialogStateMutator,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.setAttachedInboxRulesDialogStateMutator);
